import { useAddRateAgreement } from "../Hooks/useAddRateAgreement";
import { defaultRateAgreement, RateAgreement } from "../RateAgreement";
import { RateAgreementFormTabs } from "./RateAgreementFormTabs";

export const AddRateAgreement = () => {
  const { mutate: addRateAgreement } = useAddRateAgreement();

  return (
    <RateAgreementFormTabs
      title="Add Rate Agreement"
      rateAgreement={defaultRateAgreement}
      onSave={(it: RateAgreement) => {
        addRateAgreement(it);
      }}
    />
  );
};
